<template>
    <div style="background:white" class="ve-list-page">
        <div style=" display:flex; min-width:1150px; background:#fff;line-height:30px;padding-top:3px; border-bottom:2px solid #389;">
            <div style="width:80px">
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">{{ $LANG('0138', '新增') }}</span></el-link>
            </div>
            <el-select v-model="stfgSet"  size="small" @change="stfgChange(stfgSet)" style="width:90px">
                <el-option :label="$LANG('0038', '所有状态')" value="ALL"></el-option>
                <el-option :label="$LANG('2005', '未审核')" value="N"></el-option>
                <el-option :label="$LANG('1976', '已审核')" value="Y"></el-option>
            </el-select>   
            <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:120px; ">
                <span v-for="item in tabArr" :key='item.key'>
                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input :placeholder="input_hold" clearable  v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:90px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <el-select v-model="selparam2"  :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:120px; ">
                <span v-for="item in tabArr" :key='item.key'>
                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input :placeholder="input_hold" clearable  v-model="txtparam2" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px; ">
                <el-select v-model="oper2" slot="prepend"   style="width:90px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
            <el-link @click="dropSel('fldset')" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
        </div> 
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
                :table-data="tabData"
                :columnHiddenOption="columnHiddenOption"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :event-custom-option="eventCustomOption"
                :max-height="tabHeight"
                :virtual-scroll-option="virtualScrollOption"
                :scroll-width="0"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                :column-width-resize-option="columnWidthResizeOption"
                :cellSelectionOption="{enable: false}"
                id="sku_mgt_load"
                ref="tableRef">
        </ve-table>
        </div>
        <!-- 分页查询 -->
        <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto;height:88vh;">
                <div v-for="(gpitem,gpind) in formArr" :key="gpind" >
                    <div  class="one-toolbar">
                        <span class="spanRow">
                            <span v-if="gpitem.gpno==='14373'" style="font-weight:600;font-size:14px; ">物料类别属性 </span>
                            <span v-else-if="gpitem.gpno==='14374'" style="font-weight:600;font-size:14px; ">产品图片 </span> 
                            <span v-else-if="gpitem.gpno==='16135'" style="font-weight:600;font-size:14px; ">产品拼接明细【
                                <el-link :underline="false" @click="dtlAdd" > <i class="iconfont icon-xinzeng" style="font-size:12px;color:white">新增</i> </el-link> 】</span> 
                            <span v-else style="font-weight:600;font-size:14px; ">{{gpitem.gpnm}} </span>     
                        </span>
                    </div>
                    <Form :model="matRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="item.FLDNM"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <el-date-picker :disabled="saveFlag" type="date" size="medium"  v-if="item.EDCSS==='date'" v-model="matRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input :disabled="saveFlag" size="medium" v-enter-number  v-else-if="item.EDCSS==='number'" v-model="matRow[item.FLDNO]" style="width:100%" ></el-input>   
                                <el-checkbox border size="medium" v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="matRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select :disabled="saveFlag" size="medium" v-else-if="item.EDCSS==='select'" v-model="matRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.IDSEQ"></el-option>
                                </el-select>
                                <el-input v-else-if="item.FLDNO==='OUTPRC'" size="medium" v-model="matRow[item.FLDNO]" style="width:100%" >
                                    <el-select slot="append" size="small"  v-model="matRow['OUTCRCY']" placeholder="请选择货币"  style="width:140px;background:white;">
                                        <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                    </el-select>
                                </el-input>
                                <el-input v-else-if="item.FLDNO==='PRC'" size="medium" v-model="matRow[item.FLDNO]" style="width:100%" >
                                    <el-select slot="append" size="small"  v-model="matRow['CRCY']" placeholder="请选择货币"  style="width:140px;background:white;">
                                        <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                    </el-select>
                                </el-input>
                                <el-input :placeholder="item.HOLDER" size="medium" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="matRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                    <!-- 物料图片:14374 -->
                    <span v-if="gpitem.gpno==='14374'"> 
                        <div style="display:flex" >
                            <Upload
                                ref="upload"
                                name="upfile"
                                :data="uploadData"
                                :show-upload-list="false"
                                :before-upload="beforeImgFile"
                                :on-success="successImgFile"
                                :with-credentials="true"                            
                                :format="['jpg','jpeg','png' ]"
                                :max-size="4096"
                                :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize"
                                type="drag"
                                :on-progress="handleProgress"
                                :action="uploadUrl"
                                style="display: inline-block;width:200px; ">                           
                                <div style="padding: 1px 0;width:200px;height:150px;">
                                    <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                                    <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                                </div>                                                       
                            </Upload> 
                            <div style="display:flex;margin-left:30px;"  >
                                <span v-for="(item,index) in imgData" :key="index">  
                                    <el-image :disabled="saveFlag" fit="scale-down"  style="width:150px;height:125px;margin-right:30px;" :preview-src-list="[item.FILEPATH]" :src="item.FILEPATH"></el-image>
                                    <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                        <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> 删除</el-link>

                                    </div>
                                </span>
                            </div> 
                        </div>
                    </span>
                    <!-- 拼接明细 -->
                    <span v-if="gpitem.gpno==='16135'"> 
                        <el-table  :data="joinData" 
                                border       
                                class="custom-table-border"                     
                                disabled-hover
                                style="overflow:auto;margin-top:-8px;"
                                size="small"
                                :height="200" 
                                :row-class-name="tabRowClass"
                                cell-class-name="clearPadding"
                                :row-key="getDtlKey"  
                                @row-click="joinClick"
                                :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                                ref="refjoin" 
                                highlight-current-row>
                            <el-table-column label="序号" type="index" width="60"></el-table-column>              
                            <el-table-column  v-for="(item,index) in subCol.filter(item=>item.thide=='N')" :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"            
                                :sortable="item.sortable=='N'"
                                :min-width="item.width">
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <span v-else-if="item.key=='MATTY'" v-text="scope.row['CMATTY']"></span>
                                        <span v-else v-text="scope.row[item.key]"></span>
                                    </span>
                                    <span v-else >                    
                                        <el-select size="mini" v-if="item.key=='MATTY'" v-model="scope.row[item.key]">
                                            <el-option v-for="(item,index) in tyArr" :label="item.CNAME" :value="item.SUBNO" :key="index"></el-option>
                                        </el-select>
                                        <el-input clearable  @focus="inputBtn(scope.row,scope.$index,item.key)"   v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%;border:1px solid #ccc"> </el-input>  
                                        <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"   v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <el-date-picker :ref="'pos'+scope.$index+item.key" type="date" size="mini" v-else-if="item.edcss==='date'" v-model="scope.row[item.key]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                                        <el-checkbox :disabled="item.disabled=='N'?false:true" true-label="Y" false-label="N" :ref="'pos'+scope.$index+item.key"   v-else-if="item.edcss=='checkbox'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-checkbox> 
                                        <el-input   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                                    </span>
                                </template> 
                            </el-table-column> 
                            <el-table-column
                                fixed="right"
                                label="操作"
                                align="center"
                                width="75">
                                <template slot-scope="scope">

                                    <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link :disabled="editBool" @click="delJoin(scope.row, scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:10px;">删除 </span></el-link>
                                </template>
                            </el-table-column>                      
                        </el-table>
                    </span>
                </div>
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button :disabled="prevFlag" type="text" icon="iconfont icon-shangyiye"  @click="prevRec" style="margin-right:20px;">上行记录</el-button>
                    <el-button :disabled="nextFlag" type="text" icon="iconfont icon-xiayiye1"  @click="nextRec" style="margin-right:20px; ">下行记录</el-button>
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button style="margin-left:30px" type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button :disabled="saveFlag" @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- 字段设置 -->
        <el-dialog class="pub_dialog" v-dialogDrag  v-if="setWin" :visible.sync="setWin" width="480px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">字段显示设置</span>
            </div>
            <easy-win v-bind:colArr ="fldArr" @child-exit="setWin=false" @child-sure="setOk"></easy-win>
        </el-dialog>
    </div>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate } from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue'   
import easyWin from '../datamgt/easy_field.vue'
//局部注册
export default {
    name:"sku_manage",
    components: {
        pubWin,
        easyWin,
    },
    data () {
        return {
            sendVal:'PRD',    
            typeSel:false,
            prevFlag:false,
            nextFlag:false,
            crcyArr:[],
            btnWin:false,
            joinRow:{},  
            input_hold:this.$LANG('1718', '请输入查询的值'),
            cname:'',
            stfg:'',
            sortby:'',
            addWin:false,
            addProp:false,
            propFlag:'create',
            upFile:{},
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            prodCol:[],
            Accept: "png,jpg,jpeg", //上传文件格式限制
 
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            active:'first',
            perWin:false,
            stfgColor:'',
            tyArr:[],
            joinData:[],
            subCol:[],
            matRow:{},
            listurl:'',//放大的图片
 
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            treeData: [],
            loadingtree:false, 
            listIndex:'-1',
 
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            v_tabRow:{},
            v_tabIndex:'',
            chkIndex: 0,
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            vueCol:[],
            setWin:false,
            fldArr:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            columnWidthResizeOption: {
                enable: true, // default false
                minWidth: 20, // column resize min width
                // column size change
                sizeChange: ({ column, differWidth, columnWidth }) => {
                    const targetCol =this.vueCol.find(item=>item.key==column.key)
                    if (targetCol){
                        targetCol.width =columnWidth
                    }
                },
            },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            eventCustomOption: {
                bodyRowEvents: ({ row }) => ({
                    click: () => this.rowClick(row),
                }),
            },
            virtualScrollOption: { enable: false },
            txtparam2:'',
            selparam2:'',
            oper2:'like',
            paramRow:{},
            imgData:[],
            mgtModel:false,
            oper:'like',
            comboArr:{},
            v_inputrow:{},
            v_row:{},
            v_sort:'asc',
            txtparam:'',
            selparam:'IDNO',
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            delImg:[],
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            delDtlArr:[],
            notNull:[],
            uploadData:{}, //上传数据
            current:1,
            matWin:false,
 
            videoFlag:false,
            videoUploadPercent:0,
            loadWin:false,
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            dtlFlag:'create', // 
            operArr:[],
            dtlIndex:'-1',
            rowDtl:{},
            fileName:'',
            fileUrl:'',
            v_commit :true,
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','15952','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','PARENTNO','4237','','','v_sys_base','').then(res=>{
            this.crcyArr =res.result
        })
        //表单所以下拦框动态赋值
        this.comSelect()
        getBaseData('xuper_auth/getBaseData','PARENTNO','16224','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        }) 
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','15952','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15952','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
    },
    computed: {
        scrollerHeight: function() {
            return (window.innerHeight - 125) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.qryTabData()
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.joinData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'] } ))   
                this.chkIndex =this.v_tabIndex
            }
            this.btnWin =false
        },
        freshRec(row){
            this.$confirm(this.$LANG('1578', '你确定要刷新成本吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/call_procedure',
                    data: {p_user:this.v_username,corpid:this.v_corpid,p_action:'CALC_MIXPRC#'+row['IDSEQ'] },
                }).then(res=>{ 
                    if (res.code=='200'){
                        this.qryTabData()
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                    }
                })
            }).catch(()=>{})
        },
        //删除记录
        delRec(row,index){
            this.$confirm('你确定要删除此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //发起删除请求
                var vm=this;
                //选判断有没子节点
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'matno',p_value:row.IDNO ,p_table:'v_orditm'},
                }).then(res=>{  
                    if (res.result.length===0){
                        //先删除明细
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'mat_spec'},
                        }).then(res=>{      
                            if(res.code =='200')  {           
                               this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'bs_mat'},
                                }).then(res=>{   
                                    if (res.code!=='200') {
                                        this.promptWin=true
                                        this.prompt=res.result
                                    }else{
                                        this.tabData.splice(index,1)
                                    }
                                })
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                    }else{
                        this.promtWin=true
                        this.prompt='存在子记录,不能删除'
                    }
                })      
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
 
        //明细编辑、删除
        delJoin(row,index){
            this.delDtlArr.push(row)
            this.joinData.splice(index,1 )
        },
        dtlAdd(){
            let v_row ={}
            this.subCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row['MATTY']='PRD'
            v_row['QTY']= 1
            this.joinData.push(v_row)
            this.delDtlArr=[]
            this.$nextTick(()=>{
                //this.$refs['refjoin'].doLayout()
            })
        },
 
        //上行、下行记录
        prevRec(){
            this.rowIndex--
            this.nextFlag=false
            if (this.rowIndex<0){
                this.rowIndex=0
                this.prevFlag=true
            }
            this.rowClick(this.allData[this.rowIndex])
        },
        nextRec(){
            this.rowIndex++
            this.prevFlag=false
            if (this.rowIndex>this.allData.length){
                this.rowIndex=this.allData.length
                this.nextFlag=true
            }
            this.rowClick(this.allData[this.rowIndex])
        },
        inputBtn( row, index, key){
            this.v_key =key    
            if (key=='MATNO'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='V_BS_MATQRY'
                this.tableCol =this.prodCol
                this.v_key2 ='modelno'
                this.v_value2 = row['MATTY']
            }
            this.btnWin =true
        },
 
        beforeUpFile (res, file) {             
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
 
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择 jpg or png'
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出4M' 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        //表行点击事件
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
            //拼接物料  
            this.getJoinList(row.IDSEQ) 
            //行赋值    
            this.matRow =JSON.parse(JSON.stringify(row))  //深拷贝
            //物料图片
            this.qryImgData(row.IDSEQ) 
        },
        //查询图片数据
        qryImgData(idseq){
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'filety','IMG').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        joinClick(row){
            this.chkIndex =row.index
        },
        //图片删除，操作数组
        imgDel(item,index){
            this.$confirm('你确定要删除此图片吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{                
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:item['IDSEQ'],p_key2:'lstseq',p_value2:item['LSTSEQ'], p_table:'mat_img'},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        this.imgData.splice(index, 1);   
                        this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                    }else{
                        this.prompt=res.message
                        this.promptWin=true
                    }        
                })   
            }).catch(()=>{})
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'15952',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.matRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool && this.v_commit) {    
                let obj_ ={} ,vm=this 
                this.v_commit =false  
                Object.assign(obj_,vm.matRow,{ 'CORPID':this.v_corpid,'MODELNO':'MIX' }) 
                this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'bs_mat',frmid:'15952'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_=res.idseq                               
                        this.addWin =false
                        //1、主表保存   
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.joinData), p_table:'mat_join',p_idseq:idseq_ , p_action:'S' },
                        }).then(res=>{
                            if (res.code!=='200'){
                                this.promptWin=true
                                this.prompt=res.result
                            }
                        })
                        //拼接明细删除
                        for (let k=0;k<this.delDtlArr.length;k++) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'mat_join', p_action:'D' },
                            })
                        } 
                        //3、图片保存
                        for(var k=0;k<this.imgData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                            })
                        }          
                        //图片删除处理
                        for(let k=0;k<this.delImg.length;k++){
                            let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                            }).then(res=>{      
                                if(res.code !=='200')  {  
                                    this.prompt=res.message
                                    this.promptWin=true
                                }else{                          
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{ 
                                            console.log(res.result)
                                        })
                                    }
                                }        
                            })        
                        }
                        vm.qryTabData()
                    }else{
                        this.prompt =res.result
                        this.promptWin=true
                    }        
                }) 
            }
 
        },
 
        //状态审核
        recSet(row,val){
            let stfg_ =val==='Y'?this.$LANG('0134', '审核'):val==='N'?this.$LANG('0142', '反审核'):this.$LANG('0131', '删除')
            this.$confirm(this.$LANG('1564', '你确定要')+stfg_+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                let cond_=' set stfg=\''+val+'\'' 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'BS_mat',p_cond:cond_ },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData()     
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //物料明细
        getMatList(cond){
            //获取所有物料记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'MODELNO', p_value:'MIX',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond +' order by '+this.selparam +' desc',p_table:'V_BS_MAT_MIX'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData=res.result
                    this.allData =this.tabData
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
            })
        },
 
        //采购订单明细
        getJoinList(idseq){
            //获取所有物料记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq', p_value:idseq,  p_table:'V_MAT_JOIN'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.joinData=res.result
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
            }) 
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt=this.$LANG('1721', '请输入跳至页数')
            }
        },
        //初始化查询页条数
        initPage(){
            //物料明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
 
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
 
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='N'){
                    this.saveFlag=false
                }else{
                    this.saveFlag=true
                }
            }
            this.matRow =JSON.parse(JSON.stringify(row))
            this.addWin=true 
            this.rowIndex=index  
            this.v_commit =true         
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.index
        },
        rowShow(){
            this.v_row = {}
            this.v_inputrow = {}
            this.txtparam = ''
            this.txtparam2 = ''
            this.oper = 'like'
            this.oper2 = 'like'
            this.current = 1
            this.queryEvent('N')
        },
        //查询
        qryTabData(){
            this.current = 1
            this.queryEvent('N')
        },
        //新增 
        addRec(){ 
            this.addWin =true
            this.stfgCss='icon-weishenhe3'
            this.matRow={'IDSEQ':''}      
            this.FILEPATH=''
            this.imgData=[] 
            this.joinData=[]
            this.saveFlag=false
            this.v_commit =true  
        },
        //状态查询
        stfgChange(val){
            this.queryEvent('N')
        },

        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        inputQry(){
            this.current =1
            this.queryEvent('N')
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            }
            this.vueCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 : a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 : b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 : nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        queryEvent(v_where){
            let v_cond ='' , v_oper='' ,v_edcss=''
            if (this.selparam){ //列1
                this.vueCol.some(item=>{
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                } else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }
            }
            if (this.selparam2){ //列2
                v_edcss =''
                this.vueCol.some(item=>{
                    if (item['key']==this.selparam2){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper2==='like'){
                    v_cond=v_cond+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                } else{
                    if (this.txtparam2){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam2  +this.oper2+ this.txtparam2
                        }else {
                            v_cond=v_cond+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                        }
                    }
                }
            }
            if (this.stfgSet ==='ALL'){
                v_cond =v_cond +' and stfg!=\'X\''
            }else{
                v_cond =v_cond +' and stfg=\''+this.stfgSet+'\''
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.vueCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and upper('+item+')  like  upper(\'%'+ (this.v_row[item]).trim()+'%\')'
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper + this.v_row[item]
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and substr('+item+',1,10)'+ v_oper +'\''+this.v_row[item] +'\''
                        }else{
                            v_cond =v_cond +' and  '+item +v_oper+'\''+ (this.v_row[item]).trim()+'\''
                        }
                    }
                }
            })
            if (v_where =='N'){
                this.getMatList(v_cond)
            }
        },

        dropSel(val){
            if (val =='fldset'){  //字段设置显示--隐藏
                this.fldArr =[]
                getTabColOrData(this.v_url ,'V_USER_FLDSET','idseq','15952-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                    let v_setArr =res.result
                    //预处理：将 v_setArr中所有的FLDNO提取出来，转为大写，存入 Set
                    const existFldnos =new Set()
                    v_setArr.forEach(item=>existFldnos.add(item.FLDNO.toUpperCase()))
                    // 遍历 vueCol, 检查是否存在
                    this.vueCol.forEach(item =>{
                        const keyUpper = (item.key||'').toUpperCase()
                        if (!existFldnos.has(keyUpper)){
                            let v_obj ={'IDSEQ':'15952-1',LSTSEQ:'',COLWIDTH:item.width,CORPID:this.v_corpid,USERNO:this.v_username,FLDNO:item.key,FLDNM:item.title, 'VISFLAG':'Y'}
                            v_setArr.push(v_obj)
                            // 同时也添加到 Set 中，防止 vueCol 中有重复的 key 导致重复添加
                            existFldnos.add(keyUpper)
                        }
                    })
                    //构建Map,源数组 : key ---> COLWIDTH
                    const widthMap =new Map(this.vueCol.map(item=>[item.key,item.width]))
                    //遍历目标数组并更新
                    let updateColumns =v_setArr.map(col =>{
                        if (widthMap.has(col.FLDNO)){
                            return {...col ,COLWIDTH:widthMap.get(col.FLDNO)}
                        }
                        return col
                    })
                    this.fldArr =[...updateColumns]
                })
                this.setWin =true
            }
        },
        getSetList(){
            getTabColOrData(this.v_url, 'V_USER_FLDSET','idseq','15952-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                let v_data =res.result
                if (v_data && v_data.length>0) { // 有用户个性化记录
                    let v_arr=[]
                    this.columnHiddenOption['defaultHiddenColumnKeys'] =[]
                    // 1、隐藏 ，2、列宽 3、排序
                    v_data.forEach(item=>{
                        if (item['VISFLAG'] =='N') {
                            this.columnHiddenOption['defaultHiddenColumnKeys'].push(item['FLDNO'])
                        }else{
                            v_arr.push(item['FLDNO'])
                        }
                    })
                    this.$refs["tableRef"].showColumnsByKeys(v_arr)
                    this.$refs["tableRef"].hideColumnsByKeys(this.columnHiddenOption['defaultHiddenColumnKeys'])
                    //1.1 构建 Map : key -> {width,sortby,isfix} ,使用 Map 提高查找效率
                    const configMap =new Map() //建立索引映射
                    v_data.forEach(item =>{
                        configMap.set(item['FLDNO'],{COLWIDTH:item.COLWIDTH,SORTBY:item.SORTBY,ISFIX:item['ISFIX']})
                    })
                    //console.log(JSON.stringify(configMap))
                    //1.2 遍历 vueCol ,同步 width 宽度 与 冻结 fixed
                    this.vueCol.forEach(col =>{
                        const  targetCol= configMap.get(col['key'])
                        if (targetCol){
                            col.width =targetCol['COLWIDTH']
                            col.fixed =targetCol['ISFIX']=='Y'?"left":targetCol['ISFIX']=='R'?"right":false
                        }
                    })
                    //1.3 根据个性化的 SORTBY排序 来更新
                    this.vueCol.sort((a,b)=>{
                        const targetA =configMap.get(a['key'])
                        const targetB =configMap.get(b['key'])
                        const sortA = (targetA  && targetA.SORTBY!==undefined)?targetA.SORTBY:9999
                        const sortB = (targetB  && targetB.SORTBY!==undefined)?targetB.SORTBY:9999
                        return sortA - sortB
                    })
                }
            })
        },
        setOk(v_obj){
            v_obj.forEach((item,index)=>item['SORTBY']=index+1)
            this.loadWin =true
            this.$axios({
                method: 'post',
                url: 'xuper_auth/batDtlSave2' ,
                data: {p_json:JSON.stringify(v_obj), p_table:'USER_FLDSET',p_idseq:'15952-1', p_action:'S' },
            }).then(res=>{
                if (res.code=='200') {
                    this.getSetList()
                    this.setWin =false
                    this.loadWin =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.loadWin =false
                }
            })
        },

        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15952','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                const fieldRows =res.result
                    vm.tabArr =[]
                    vm.vueCol =[]
                    fieldRows.forEach(item => {
                        const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                        vm.tabArr.push({
                            title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            sortable: item.SORTABLE,
                        })
                        if (item.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title,
                            type: item.EDCSS === 'checkbox' ? 'check' : item.EDCSS,
                            edcss: item.EDCSS,
                            align: item.align,
                            width: Number(item.width),
                            thide:item.THIDE,
                            fhide:item.FHIDE,
                            sortable:false,
                            disabled:item.DISABLED,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}, h) => {
                                if (item.EDCSS =='number') {
                                    return (
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                            </div>
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                    <option value="=">=</option>
                                                    <option value=">">&gt;</option>
                                                    <option value="<">&lt;</option>
                                                    <option value="!=">!=</option>
                                                </select>
                                                <el-input disabled={item.EDCSS=='image'} v-model={this.v_row[column.key]} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                            </div>
                                        </div>
                                    )
                                }else{
                                    if (item.EDCSS=='checkbox'){
                                        return (
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                </div>
                                                <div style="display:flex">
                                                    <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]} on-change={()=>{this.inputQry()}}>
                                                        <el-option value="Y" label="是"></el-option>
                                                        <el-option value="N" label="否"></el-option>
                                                    </el-select>
                                                </div>
                                            </div>
                                        )
                                    }else {
                                        return (
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                </div>
                                                <div style="display:flex">
                                                    <input disabled={item.EDCSS=='image'} v-model={this.v_row[column.key]} on-keyup={(event)=>{if (event.key=='Enter') this.inputQry()}} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></input>
                                                </div>
                                            </div>
                                        )
                                    }
                                }
                            },
                            renderBodyCell: ({row}) => item.EDCSS === 'checkbox'
                                ? <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                : row[item.key],
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => (
                            <div>
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link>
                            </div>
                        ),
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 295,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                <i class="iconfont icon-shuaxin" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={this.disabled} on-click={() => this.freshRec(row)} underline={false}>
                                    <span style="font-size:12px;margin-right:10px;">{this.$LANG('0159', '刷新成本')}</span>
                                </el-link>
                                <i class="iconfont icon-chazhao" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={this.disabled} on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}>
                                    <span style="font-size:12px;margin-right:10px;">{this.$LANG('0139', '查看')}</span>
                                </el-link>
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={this.editBool} on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}>
                                        <span style="font-size:12px;margin-right:10px;">{this.$LANG('1639', '编辑')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={this.cfmBool} on-click={() => this.recSet(row, 'Y')} underline={false}>
                                        <span style="font-size:12px;margin-right:10px;">{this.$LANG('0134', '审核')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'Y' ? <span>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={this.cfmBool} on-click={() => this.recSet(row, 'N')} underline={false}>
                                        <span style="font-size:12px;margin-right:10px;">{this.$LANG('0137', '弃审')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG !== 'Y' ? <span>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={this.cancelBool} on-click={() => this.recSet(row, 'X')} underline={false}>
                                        <span style="font-size:11px;margin-right:10px;">{this.$LANG('0257', '作废')}</span>
                                    </el-link>
                                </span> : null}
                            </div>
                        ),
                    })
                    vm.getSetList()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15952','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.subCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .item-width{
        width:32%;
        height: 20px !important;
    }
 
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
 
    .active { 
        color:#D200D2; 
    } 
 
</style>
<style lang="less">
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
     .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
